export const USER_INFO_LOADING = 'USER_INFO_LOADING';
export const USER_INFO_SUCCESS = 'USER_INFO_SUCCESS';
export const USER_INFO_FAILED = 'USER_INFO_FAILED';
export const USER_INFO_CLEAR = 'USER_INFO_CLEAR';
export const FETCH_FEATURE_FLAGS_LOADING = 'FETCH_FEATURE_FLAGS_LOADING';
export const FETCH_FEATURE_FLAGS_SUCCESS = 'FETCH_FEATURE_FLAGS_SUCCESS';
export const FETCH_FEATURE_FLAGS_FAILURE = 'FETCH_FEATURE_FLAGS_FAILURE';
export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_FEATURE_FLAGS = 'SET_FEATURE_FLAGS';
